/**
 * Note: define PHP constant \IllicitWeb\SCROLL_THRESHOLD in child theme
 * functions.php in order to change the point at which <body> get the "scrolled"
 * class.
 * 
 */

import { registerScrollDetectEvent } from "./scroll-detect";

declare const jQuery: any;
const $ = jQuery;
const $body = $("body");
const className = "scrolled";
const scrollThreshold: number = (window["iw"].SCROLL_THRESHOLD === undefined) ? 90 : window["iw"].SCROLL_THRESHOLD;

function addClass()
{
	$body.addClass(className).trigger("scrolled");
}

function removeClass()
{
	$body.removeClass(className).trigger("unscrolled");
}

export function init()
{
	registerScrollDetectEvent(addClass, removeClass, () => scrollThreshold);
}
